<template>
	<f7-toolbar  class="dz-tab" tabbar bottom no-shadow no-hairline >
		<f7-link href="/" :animate="false" bgColor="aa">
			<div class="dz_tabs_item flex-column-center">
				<img v-if="!isSelected(1)" src="@/assets/tabs/dashboard.png" />
				<img v-else-if="lm_env=='dz'" src="@/assets/tabs/dashboard_active.png" />
				<img v-else src="@/assets/tabs/dashboard_active_jz.png" />
				<p :class="{dz_active:isSelected(1)}">首页</p>
			</div>
		</f7-link>
		<f7-link @click="toMine" :animate="false" bgColor="aa">
			<div class="dz_tabs_item flex-column-center">
				<img v-if="!isSelected(2)" src="@/assets/tabs/mine.png" />
				<img v-else-if="lm_env=='dz'" src="@/assets/tabs/mine_active.png" />
				<img v-else src="@/assets/tabs/mine_active_jz.png" />
				<p :class="{dz_active:isSelected(2)}">我的</p>
			</div>
		</f7-link>
	</f7-toolbar>
</template>

<script>
export default {
	data() {
		return {}
	},
	props: {
		moduleType: {
			default: 1,
			type: Number
		}
	},
	methods: {
		isSelected(num) {
			return this.moduleType == num;
		},
		toMine() {
			this.$f7router.navigate('/mine/', { animate: false });
		},
	},
}
</script>

<style lang="less" scoped>
.dz_tabs_item {
  img {
    width: 1.375rem;
    height: 1.375rem;
  }

  p {
    font-size: 0.625rem;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.9375rem;
    margin-top: 0.1875rem;
    text-align: center;

    &.dz_active {
      color: @primary-color;
    }
  }

  &.dz_tabs_menu {
    width: 3.5rem;
    height: 3.5rem;
    margin-bottom: 3rem;
    position: relative;

    & > div {
      width: 3.5rem;
      height: 3.5rem;
      background-color: @primary-color;
      border-radius: 0.5rem;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      line-height: 3.5rem;
      transform: rotate(45deg);
    }

    p {
      position: absolute;
      top: 1.35rem;
      left: 0.5rem;
      font-size: 3.5rem;
      color: #fff;
    }
  }
}
</style>
